import "./style.scss";

type SliderObservationProps = {
	maxValue: number;
	currentValue: number;
};

export const SliderObservation = ({
	maxValue,
	currentValue,
}: SliderObservationProps) => {
	const progress = maxValue === 0 ? 100 : (currentValue / maxValue) * 100;

	return (
		<input
			id="slider"
			type="range"
			max={maxValue === 0 ? 1 : maxValue}
			defaultValue={currentValue}
			disabled
			style={{
				["--progress" as string]: `${progress}%`,
			}}
		/>
	);
};

export default SliderObservation;
